module.exports = __webpack_public_path__ + "static/img/top_logo@1x.f1b18cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/top_logo@1x.png
// module id = Qhxg
// module chunks = 3